import { PATHS } from '@src/containers/App/TimeTracker/constants';
import { getPeriodEmptyUserDataText } from './getPeriodEmptyUserDataText';

const getSelectedUserLine = (intl, selectedIndividualUser) => {
  if (!selectedIndividualUser) return null;

  const name = `${selectedIndividualUser.firstName} ${selectedIndividualUser.lastName}`;

  return intl.formatMessage(
    { id: 'timeTracker.reports.emptyUserData.selectedUser' },
    { name },
  );
};

/**
 * Builds export lines matching EmptyUserData UI content.
 * @param {Object} intl - react-intl intl instance
 * @param {Object} params
 * @param {string} [params.reportType='']
 * @param {Object|null} [params.selectedIndividualUser=null]
 * @param {string|null} [params.startDate=null]
 * @param {string|null} [params.endDate=null]
 * @param {string} [params.queriedPeriod=''] - Pre-formatted period from useReportManagerDt
 * @param {Object|null} [params.modificationEmptyState=null] - { user, message }
 * @returns {string[]}
 */
export const getEmptyUserDataExportLines = (
  intl,
  {
    reportType = '',
    selectedIndividualUser = null,
    startDate = null,
    endDate = null,
    queriedPeriod = '',
    modificationEmptyState = null,
  } = {},
) => {
  const periodLine = getPeriodEmptyUserDataText(intl, startDate, endDate, queriedPeriod);

  if (reportType === PATHS.HOLIDAYS) {
    const lines = [];
    const selectedUserLine = getSelectedUserLine(intl, selectedIndividualUser);

    if (selectedUserLine) {
      lines.push(selectedUserLine);
    }

    lines.push(periodLine);

    if (selectedIndividualUser) {
      lines.push(intl.formatMessage({ id: 'timeTracker.reports.emptyUserData.holidays' }));
    }

    return lines;
  }

  if (reportType === PATHS.MODIFICATIONS) {
    const lines = [];

    if (modificationEmptyState?.user) {
      lines.push(
        intl.formatMessage(
          { id: 'timeTracker.reports.emptyUserData.selectedUser' },
          { name: modificationEmptyState.user },
        ),
      );
    }

    lines.push(periodLine);

    if (modificationEmptyState?.message) {
      lines.push(modificationEmptyState.message);
    }

    return lines;
  }

  const lines = [];
  const selectedUserLine = getSelectedUserLine(intl, selectedIndividualUser);

  if (selectedUserLine) {
    lines.push(selectedUserLine);
  }

  lines.push(periodLine);
  lines.push(intl.formatMessage({ id: 'work.direction.table.emptyState' }));

  return lines;
};
